import React from "react";
import styled from "styled-components";
import { Filament } from "./Filament";

function App() {
  return (
    <AppContainer>
      <TheRest>
        <Filament />
      </TheRest>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 100vh;
  background-color: #282c34;
  font-size: calc(10px + 2vmin);
  color: white;
  padding: 8px;
`;

const TheRest = styled.div`
  height: 100%;
  width: 100%;
`;

export default App;
